/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * Get a generated event subscription path.
 * @param {string} [subscriptionId] The id of the event subscription.
 * @export
 * @returns {string} A generated event subscription path.
 */
export const getEventSubscriptionPath = (subscriptionId?: string): string => {
  return subscriptionId ? `/event-subscriptions/${subscriptionId}` : `/event-subscriptions`;
};
